import React, { Component } from "react";
import { withLocalize, Translate } from "react-localize-redux";
import { Link, withRouter } from "react-router-dom";
import NavBar from "../NavBar/index";
import "./style.css";
import imgLogo from "../../06-assets/images/home/logo.png";
import imgName from "../../06-assets/images/home/site-name.png";
import { Button } from "reactstrap";
import { Collapse } from "reactstrap";

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: "",
            isMenuOpen: false,
        };
        this.handleLanguageChange = this.handleLanguageChange.bind(this);
    }

    handleLanguageChange(lang) {
        this.props.setActiveLanguage(lang.code);
    }

    render() {
        return (
            <Translate>
                {({ translate }) => (
                    <div className="con-header">
                        <div className="logo">
                            <Link to="/admin">
                                <img alt="logo" src={imgLogo} />
                            </Link>
                        </div>
                        <div className="name-nav">
                            <div className="name-search">
                                <div className="name">
                                    <img alt="back" src={imgName} />
                                </div>
                                <div className="search">
                                    <input
                                        value={this.state.search}
                                        onChange={(e) => {
                                            this.setState({
                                                search: e.target.value,
                                            });
                                        }}
                                        placeholder={
                                            this.props.translate("search") +
                                            "..."
                                        }
                                        className="search-input"
                                        type="text"
                                    />
                                    <input
                                        className="btn-search"
                                        onClick={() => {
                                            this.state.search &&
                                                this.props.history.push(
                                                    `/products?keyword=${this.state.search}`,
                                                );
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="nav-lang">
                                <Button
                                    onClick={() => {
                                        this.setState({
                                            isMenuOpen: !this.state.isMenuOpen,
                                        });
                                    }}
                                    size="sm"
                                    className="toggler"
                                >
                                    <i className="fas fa-bars" />
                                </Button>
                                <div className="mb-nav">
                                    <Collapse isOpen={this.state.isMenuOpen}>
                                        <NavBar />
                                        {/*<LanguageSelector*/}
                                        {/*activeLanguage={this.props.activeLanguage}*/}
                                        {/*languages={this.props.languages}*/}
                                        {/*onLanguageChange={this.handleLanguageChange}/>*/}
                                    </Collapse>
                                </div>
                                <div className="navbar">
                                    <NavBar />
                                </div>
                                <div className="lang-selector">
                                    {/*<LanguageSelector*/}
                                    {/*activeLanguage={this.props.activeLanguage}*/}
                                    {/*languages={this.props.languages}*/}
                                    {/*onLanguageChange={this.handleLanguageChange}/>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </Translate>
        );
    }
}

export default withRouter(withLocalize(Header));



// WEBPACK FOOTER //
// ./src/04-containers/Header/index.js